import { Component, inject } from '@angular/core';
import { NzModalRef } from 'ng-zorro-antd/modal';

@Component({
  selector: 'app-modal-generate-month',
  templateUrl: './modal-generate-month.component.html',
  styleUrls: ['./modal-generate-month.component.css']
})
export class ModalGenerateMonthComponent {
  private readonly _modalRef: NzModalRef = inject(NzModalRef);

  checked: boolean = false;

  constructor() {}

  closeModal() {
    this._modalRef.close();
  }

  save() {
    this._modalRef.close(this.checked);
  }
}
